import { useMemo } from 'react';

import { Dropdown, DropdownProps } from 'primereact/dropdown';

import { useGetStringMapsQuery } from '@/services/lookups/hooks';

import './StringMapDropdown.css';

type StringMapDropdownProps = DropdownProps & {
  label?: string;
  objectTypeCode: number;
  attributeName: string;
  appendTo?: string;
};

export const StringMapDropdown = ({
  label,
  objectTypeCode,
  attributeName,
  appendTo,
  ...dropdownProps
}: StringMapDropdownProps) => {
  const { data = [], isLoading } = useGetStringMapsQuery({
    objectTypeCode,
    attributeName,
  });

  const options = useMemo(() => {
    return data.map((item) => ({
      label: item.value,
      value: Number(item.attributeValue),
    }));
  }, [data]);

  return (
    <div className={`string-map-dropdown ${label ? 'label-input-group' : ''}`}>
      {label && <label>{label}</label>}
      <Dropdown
        appendTo={appendTo}
        options={options}
        filterPlaceholder="Search"
        filter
        filterInputAutoFocus={true}
        loading={isLoading}
        showClear
        {...dropdownProps}
      />
    </div>
  );
};
